import api from '../../utils/api';
import { getApiUrl } from '../../utils/config';

// Get products for a specific category (public view)
export const getCategoryProducts = async (categoryId) => {
  try {
    const response = await api.get(getApiUrl(`/categories/${categoryId}/products`));
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get a specific product details (public view)
export const getProductDetails = async (productId) => {
  try {
    const response = await api.get(getApiUrl(`/products/${productId}`));
    return response.data; 
  } catch (error) {
    throw error;
  }
};

// Create a new product for a store (admin only)
export const createProduct = async (storeSlug, productData) => {
  try {
    // For FormData (file uploads), remove Content-Type to let browser set it
    const config = {
      headers: {
        'Content-Type': undefined,
      },
    };
    const response = await api.post(getApiUrl(`/stores/${storeSlug}/products`), productData, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update an existing product (admin only)
export const updateProduct = async (productId, productData) => {
  try {
    // For FormData (file uploads), remove Content-Type to let browser set it
    const config = {
      headers: {
        'Content-Type': undefined,
      },
    };
    
    // Add _method field to FormData to indicate PUT request
    productData.append('_method', 'PUT');
    
    const response = await api.post(getApiUrl(`/products/${productId}`), productData, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a product (admin only)
export const deleteProduct = async (productId) => {
  try {
    const response = await api.delete(getApiUrl(`/products/${productId}`));
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Toggle product status (admin only)
export const toggleProductStatus = async (productId) => {
  try {
    const response = await api.patch(getApiUrl(`/products/${productId}/toggle-status`));
    return response.data;
  } catch (error) {
    throw error;
  }
}; 